// extracted by mini-css-extract-plugin
module.exports = {"sizeSelect":"AtPageSize_sizeSelect__1fPY8"};